<ng-container>
  <asax-header-search-popover>
    <content *ngTemplateOutlet="searchContent"></content>
  </asax-header-search-popover>
</ng-container>

<ng-template #searchContent>
  <div class="container-fluid">
    <div class="row g-2">
      <div *ngFor="let searchInputGroup of searchInputGroups"
           class="col"
           style="width: 200px;">
        <h5 class="text-nowrap">
          <i class="fa-light fa-{{searchInputGroup.icon}} me-1"></i>
          <span class="fw-bold">{{searchInputGroup.title}}</span>
        </h5>
        <ng-container *ngFor="let searchInput of searchInputGroup.searchInputs">
          <div class="mt-2">
            <asax-header-search-input-container [searchInput]="searchInput">
            </asax-header-search-input-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
